import React from "react";
import "../../App.css";
import ServiceSection from "../ServiceSection";
import HeaderInvert from "../HeaderInvert";
import CardSection from "../CardSection";
import BeneficeSection from "../BeneficeSection";
import Cta from "../Cta";
import Footer from "../Footer";

export default function Services() {
  return (
    <>
      <ServiceSection />
      <HeaderInvert text="VISUALS THAT SELL BEFORE YOU SPEAK." />
      <CardSection />
      <HeaderInvert text="LUXURY CAPTURED, VALUE MAXIMIZED." />
      <BeneficeSection />
      <HeaderInvert text="UNLIMITED REACH, LOCAL RESULTS." />
      <Cta
        headline="Ready to bring your ideas to life?"
        subtext="Contact us today and let’s make it happen."
        buttonLink="./portfolio"
        buttonText="Get in Touch"
      />
      <Footer />
    </>
  );
}
